import clueFailReport from './clueFailReport'
export default clueFailReport
